import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { getTranslatedEntityForPage } from "src/util/functions/entity"
import { EntityPages } from "src/util/types/dataModels/entityDefinition"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogWorkOrderEntities',
  props: {
  entitiesRemoved: {
    type: Number,
    required: true,
  },

  entitiesAdded: {
    type: Number,
    required: true,
  },

  entitiesToDo: {
    type: Number,
    required: true,
  },

  entitiesTotal: {
    type: Number,
    required: true,
  },

  entity: {
    type: String as PropType<EntityPages>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const { t } = useI18n()

const translatedEntity = computed(() => getTranslatedEntityForPage(props.entity, true))
const labelTitle = computed(() =>
  t("sfxDialogWorkOrderEntities.title", { entity: translatedEntity.value })
)
const labelRemoved = computed(() =>
  t("sfxDialogWorkOrderEntities.label_removed", { entity: translatedEntity.value })
)
const labelAdded = computed(() =>
  t("sfxDialogWorkOrderEntities.label_added", { entity: translatedEntity.value })
)
const labelToDo = computed(() =>
  t("sfxDialogWorkOrderEntities.label_to_do", { entity: translatedEntity.value })
)
const labelTotal = computed(() =>
  t("sfxDialogWorkOrderEntities.label_total", { entity: translatedEntity.value })
)
const labelSaveChanges = computed(() => t("sfxDialogWorkOrderEntities.label_save_changes"))
const labelBtnCancel = t("sfxButtons.btn_cancel")
const labelBtnSave = t("sfxButtons.btn_save")

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title text-h3 q-pb-xs" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(labelTitle.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 sfx-confirm-content column items-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", { innerHTML: labelRemoved.value }, null, 8, _hoisted_1),
              _createElementVNode("div", null, _toDisplayString(props.entitiesRemoved), 1),
              _hoisted_2,
              _createElementVNode("div", { innerHTML: labelAdded.value }, null, 8, _hoisted_3),
              _createElementVNode("div", null, _toDisplayString(props.entitiesAdded), 1),
              _hoisted_4,
              _createElementVNode("div", { innerHTML: labelToDo.value }, null, 8, _hoisted_5),
              _createElementVNode("div", null, _toDisplayString(props.entitiesToDo), 1),
              _hoisted_6,
              _createElementVNode("div", { innerHTML: labelTotal.value }, null, 8, _hoisted_7),
              _createElementVNode("div", null, _toDisplayString(props.entitiesTotal), 1),
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(labelSaveChanges.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md gap-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(labelBtnCancel),
                class: "col"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _unref(labelBtnSave),
                class: "col"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})